<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import { buildFlowResponseEntries } from '../helpers/whatsappFlowResponse.js';

const { content, contentAttributes } = useMessageContext();
const { t } = useI18n();

const responseEntries = computed(() => {
  const response =
    contentAttributes.value?.whatsappFlowResponse?.responseJson ?? {};

  return buildFlowResponseEntries(response);
});
</script>

<template>
  <BaseBubble
    class="min-w-64 max-w-lg overflow-hidden"
    data-bubble-name="whatsapp-flow-response"
  >
    <div class="flex items-center gap-2 border-b border-n-weak px-4 py-3">
      <span class="i-lucide-list-checks size-4 shrink-0 text-n-brand" />
      <span class="font-medium text-n-slate-12">
        {{ content || t('CONVERSATION.WHATSAPP_FLOW_RESPONSE') }}
      </span>
    </div>
    <dl v-if="responseEntries.length" class="space-y-3 px-4 py-3">
      <div v-for="entry in responseEntries" :key="entry.key">
        <dt class="text-xs font-medium text-n-slate-10">
          {{ entry.label }}
        </dt>
        <dd class="mt-0.5 whitespace-pre-wrap break-words text-n-slate-12">
          {{ entry.value }}
        </dd>
      </div>
    </dl>
  </BaseBubble>
</template>
